import '../styles/Banner.css'
import { useState, useEffect } from 'react'
import { useChampiList } from './useChampiList'

import logobanner from '../assets/logobanner.png'
import logopopup from '../assets/logopopup.png'


function Banner() {
    const [showPopup, setShowPopup] = useState(false)
    const [menuOpen, setMenuOpen] = useState(false)
    const [isMobile, setIsMobile] = useState(false)

    const champiList = useChampiList()

    useEffect(() => {
        const mobile = window.innerWidth <= 768
        setIsMobile(mobile)
        setMenuOpen(!mobile)

        const handleResize = () => setIsMobile(window.innerWidth <= 768)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])



    return (
        <>
            <div className='myco-banner'>
                <img src={logobanner} alt='Myco Quiz' className='myco-logo' />

                <button
                    className='help-button'
                    onClick={() => setShowPopup(true)}> ?
                </button>

                <button
                    className='burger-button'
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Menu"
                >
                    <div className={`burger-icon ${menuOpen ? 'open' : ''}`}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </button>
            </div>

        <div className={`burger-menu ${menuOpen ? 'open' : ''}`}>
            <div className="burger-menu-header">
                <h3 className="burger-menu-title">Liste des champignons disponibles</h3>
            </div>

            <ul className="burger-menu-list">
                {champiList
                    .slice()
                    .sort((a, b) => a.nom.localeCompare(b.nom))
                    .map((c) => (
                        <li key={c.id} className="burger-menu-item">
                            <img src={c.cover} alt={c.nom} className="burger-menu-img" />
                            <span>{c.nom}</span>
                        </li>
                    ))}
            </ul>
        </div>

            {isMobile && menuOpen && (
                <div className="burger-menu-overlay" onClick={() => setMenuOpen(false)} />
            )}

        {showPopup && (
            <div className="popup-overlay" onClick={() => setShowPopup(false)}>
                <div className="popup" onClick={(e) => e.stopPropagation()}>
                <div className="popup-header">
                    <h2>Bienvenue dans <img src={logopopup} alt="Mycoquiz" className="popup-header-logo" /></h2>
                </div>
                <div className="popup-body">
                    <p>
                        Le but du jeu: trouver le champignon à deviner.<br/><br/>

                        Pour commencer, tape quelques lettres d’un champignon qui te vient en tête dans la barre de recherche.<br/>
                        Une liste déroulante apparaîtra : sélectionne ensuite le champignon de ton choix.<br/>
                        Après chaque recherche, le jeu t’indiquera les caractéristiques communes entre ta proposition et le champignon à deviner.<br/>
                        Ces informations sont tes indices pour te rapprocher de la bonne réponse.<br/>
                        Utilise ces indices pour tester d’autres champignons, jusqu’à découvrir le champignon à deviner<br/><br/>

                        Tu as désormais toutes les cartes en main…<br/>
                        Je te nomme officiellement chasseur de champignons !
                    </p>
                    <button
                        className="close-popup"
                        onClick={() => setShowPopup(false)}
                    >
                        Fermer
                    </button>
                </div>
                </div>
            </div>
        )}
        </>
    )
}

export default Banner